module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cancel":"Cancel","reorderResource":"Reorder resources","save":"Save"},"fr":{"cancel":"Annuler","reorderResource":"Réorganiser les ressources","save":"Sauvegarder"}}')
  delete Component.options._Ctor
}
